// extracted by mini-css-extract-plugin
module.exports = {"container":"timeline_container__13HhC","slides":"timeline_slides__xkQxx"};